import React from 'react';
import { useTranslate } from '../../lib'

const GrammarSpelling = ({ data }) => {
  const getClass = (accuracy) => {
    return accuracy > 79 ? 'text-[#00d769]' : 'text-[#FF303E]';
  };

  const proofreadScore = (data?.proofread * 100).toFixed(1);
  const listproofread = data?.listproofread || [];
  const { t } = useTranslate();

  return (
    <div className="w-full text-[#0b5fa3] font-bold text-sm h-[calc(100vh-200px)] overflow-y-auto">
      {/* Header Section */}
      <div className="h-[30%] min-h-[200px] flex justify-between items-center px-10">
        <div className="w-[30%] flex flex-col items-center">
          <h4 className="text-center w-full mb-2">{t('common.score')}</h4> 
          <span className="font-sans text-[#0b5fa3] text-[65px] font-bold">
            {proofreadScore}%
          </span>
        </div>

        <div className="w-[50%] flex flex-wrap justify-center">
          <h4 className="w-full text-center text-[#575756]">
            {t('reports.style.feedback')}
          </h4>
        </div>

        <div className="text-center w-[20%] pt-[3%] flex flex-col items-end">
          <h4>{t('reports.highlights')}</h4>
          <img 
            src="/icons/sentiment2.png" 
            alt="Sentiment Analysis" 
            className="w-[142px] h-[143px] object-contain mt-2"
          />
        </div>
      </div>

      {/* Body Section */}
      <div className="border-2 border-gray-100 rounded-lg flex justify-evenly mx-5 mb-20">
        <div className="w-full flex flex-col">
          <h2 className="text-center py-4">{t('reports.grammar.greetingVerification')} {proofreadScore}%</h2>
          
          <div className="w-full max-h-[400px] overflow-auto 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-blue-500 
            scrollbar-track-rounded-md scrollbar-thumb-rounded-md px-4">
            
            {listproofread.map((item, index) => (
              <div key={index} className="pb-2.5 border-b-2 border-[#b0b1b3] mb-4">
                <div className="flex">
                  <div className="flex items-center">
                    <span className={`px-4 py-2 ml-2.5 ${getClass(item.score * 100)}`}>
                      {item.user}
                    </span>
                    <b className="text-xs px-2.5 text-black">
                      {t('reports.grammar.sentenceWithoutErrors')}
                    </b>
                  </div>
                </div>
                <div className="text-black mt-2 pl-4">
                  {item.correctPhrase}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrammarSpelling;